import { render } from "./innerheader.vue?vue&type=template&id=3e672b9f&scoped=true"
import script from "./innerheader.vue?vue&type=script&lang=js"
export * from "./innerheader.vue?vue&type=script&lang=js"

import "./innerheader.vue?vue&type=style&index=0&id=3e672b9f&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3414373455/src/platform-insurance-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e672b9f"]])

export default __exports__